module.exports = __webpack_public_path__ + "static/media/default-image.35e2f66b.png";